import { Box, Collapse, Alert } from '@mui/material';

const WarningStacks = ({ alert }) => {
  // More detailed condition check
  if (!alert?.show || !alert?.message) {
    return null;
  }
  
  // Convert string message to array if it's not already an array
  const messages = Array.isArray(alert.message) ? alert.message : [alert.message];
  
  return (
    <Box
      sx={{
        width: '25%',
        display: 'flex',
        position: 'fixed',
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column-reverse",
        bottom: 20,
        right: 20,
        zIndex: 9999,
      }}
    >
      <Collapse in={Boolean(alert.show)} timeout="auto" unmountOnExit>
        {messages.map((value, index) => (
          <Alert
            key={`${value}-${index}`}
            severity={alert.type || 'info'}
            sx={{
              borderRadius: '18px',
              display: 'flex',
              alignItems: 'center',
              fontSize: '1rem',
              padding: '10px',
              minWidth: '200px',
              margin: 1
            }}
          >
            {value}
          </Alert>
        ))}
      </Collapse>
    </Box>
  );
};

export default WarningStacks;